import type { MarketingInfo } from './application-types.ts'
import { sanitizeUtmParam } from './utm-params.ts'

const EXPRESS_PATH = '/apply/express'

const EXPRESS_MARKETING_QUERY_FIELDS = [
  ['utm_campaign', 'campaign'],
  ['utm_medium', 'medium'],
  ['utm_source', 'source'],
  ['utm_referrer', 'referrer'],
  ['utm_officer', 'officer'],
  ['promo', 'promoCode'],
] as const

export function emptyMarketingInfo(): MarketingInfo {
  return {
    campaign: '',
    medium: '',
    source: '',
    referrer: '',
    officer: '',
    promoCode: '',
  }
}

export function marketingHasValues(marketing: MarketingInfo): boolean {
  return Boolean(
    marketing.campaign
    || marketing.medium
    || marketing.source
    || marketing.referrer
    || marketing.officer
    || marketing.promoCode
  )
}

export function marketingForExpressSnapshot(marketing?: MarketingInfo): MarketingInfo {
  if (!marketing) {
    return emptyMarketingInfo()
  }
  return {
    campaign: sanitizeUtmParam(marketing.campaign),
    medium: sanitizeUtmParam(marketing.medium),
    source: sanitizeUtmParam(marketing.source),
    referrer: sanitizeUtmParam(marketing.referrer),
    officer: sanitizeUtmParam(marketing.officer),
    promoCode: sanitizeUtmParam(marketing.promoCode),
  }
}

export function buildExpressHandoffUrl(marketing: MarketingInfo): string {
  const params = new URLSearchParams()
  for (const [queryKey, field] of EXPRESS_MARKETING_QUERY_FIELDS) {
    const value = sanitizeUtmParam(marketing[field])
    if (value) {
      params.set(queryKey, value)
    }
  }
  const query = params.toString()
  return query ? `${EXPRESS_PATH}?${query}` : EXPRESS_PATH
}

export function readMarketingFromSearchParams(params: URLSearchParams): MarketingInfo {
  const marketing = emptyMarketingInfo()
  for (const [queryKey, field] of EXPRESS_MARKETING_QUERY_FIELDS) {
    marketing[field] = sanitizeUtmParam(params.get(queryKey))
  }
  return marketing
}

export function hasExpressMarketingQuery(params: URLSearchParams): boolean {
  return EXPRESS_MARKETING_QUERY_FIELDS.some(([queryKey]) => {
    return sanitizeUtmParam(params.get(queryKey)).length > 0
  })
}
